
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_18wu0_lw6ey_93",
  "box": "awsui_box_18wu0_lw6ey_207",
  "p-variant": "awsui_p-variant_18wu0_lw6ey_207",
  "color-default": "awsui_color-default_18wu0_lw6ey_207",
  "b-variant": "awsui_b-variant_18wu0_lw6ey_207",
  "strong-variant": "awsui_strong-variant_18wu0_lw6ey_207",
  "code-variant": "awsui_code-variant_18wu0_lw6ey_207",
  "pre-variant": "awsui_pre-variant_18wu0_lw6ey_207",
  "samp-variant": "awsui_samp-variant_18wu0_lw6ey_207",
  "h1-variant": "awsui_h1-variant_18wu0_lw6ey_211",
  "h2-variant": "awsui_h2-variant_18wu0_lw6ey_211",
  "h3-variant": "awsui_h3-variant_18wu0_lw6ey_211",
  "h4-variant": "awsui_h4-variant_18wu0_lw6ey_211",
  "h5-variant": "awsui_h5-variant_18wu0_lw6ey_211",
  "small-variant": "awsui_small-variant_18wu0_lw6ey_215",
  "a-variant": "awsui_a-variant_18wu0_lw6ey_219",
  "font-size-default": "awsui_font-size-default_18wu0_lw6ey_223",
  "font-weight-default": "awsui_font-weight-default_18wu0_lw6ey_263",
  "key-label-variant": "awsui_key-label-variant_18wu0_lw6ey_305",
  "value-large-variant": "awsui_value-large-variant_18wu0_lw6ey_312",
  "font-weight-heavy": "awsui_font-weight-heavy_18wu0_lw6ey_319",
  "color-inverted": "awsui_color-inverted_18wu0_lw6ey_324",
  "color-text-label": "awsui_color-text-label_18wu0_lw6ey_327",
  "color-text-body-secondary": "awsui_color-text-body-secondary_18wu0_lw6ey_330",
  "color-text-status-error": "awsui_color-text-status-error_18wu0_lw6ey_333",
  "color-text-status-success": "awsui_color-text-status-success_18wu0_lw6ey_336",
  "color-text-status-info": "awsui_color-text-status-info_18wu0_lw6ey_339",
  "color-text-status-inactive": "awsui_color-text-status-inactive_18wu0_lw6ey_342",
  "color-text-status-warning": "awsui_color-text-status-warning_18wu0_lw6ey_345",
  "color-inherit": "awsui_color-inherit_18wu0_lw6ey_348",
  "font-size-body-s": "awsui_font-size-body-s_18wu0_lw6ey_351",
  "font-size-body-m": "awsui_font-size-body-m_18wu0_lw6ey_356",
  "font-size-heading-xs": "awsui_font-size-heading-xs_18wu0_lw6ey_360",
  "font-size-heading-s": "awsui_font-size-heading-s_18wu0_lw6ey_364",
  "font-size-heading-m": "awsui_font-size-heading-m_18wu0_lw6ey_369",
  "font-size-heading-l": "awsui_font-size-heading-l_18wu0_lw6ey_374",
  "font-size-heading-xl": "awsui_font-size-heading-xl_18wu0_lw6ey_379",
  "font-size-display-l": "awsui_font-size-display-l_18wu0_lw6ey_384",
  "font-weight-light": "awsui_font-weight-light_18wu0_lw6ey_389",
  "font-weight-normal": "awsui_font-weight-normal_18wu0_lw6ey_392",
  "font-weight-bold": "awsui_font-weight-bold_18wu0_lw6ey_395",
  "t-left": "awsui_t-left_18wu0_lw6ey_402",
  "t-right": "awsui_t-right_18wu0_lw6ey_406",
  "t-center": "awsui_t-center_18wu0_lw6ey_410",
  "p-n": "awsui_p-n_18wu0_lw6ey_511",
  "p-top-n": "awsui_p-top-n_18wu0_lw6ey_515",
  "p-vertical-n": "awsui_p-vertical-n_18wu0_lw6ey_516",
  "p-right-n": "awsui_p-right-n_18wu0_lw6ey_520",
  "p-horizontal-n": "awsui_p-horizontal-n_18wu0_lw6ey_521",
  "p-bottom-n": "awsui_p-bottom-n_18wu0_lw6ey_525",
  "p-left-n": "awsui_p-left-n_18wu0_lw6ey_530",
  "p-xxxs": "awsui_p-xxxs_18wu0_lw6ey_535",
  "p-top-xxxs": "awsui_p-top-xxxs_18wu0_lw6ey_539",
  "p-vertical-xxxs": "awsui_p-vertical-xxxs_18wu0_lw6ey_540",
  "p-right-xxxs": "awsui_p-right-xxxs_18wu0_lw6ey_544",
  "p-horizontal-xxxs": "awsui_p-horizontal-xxxs_18wu0_lw6ey_545",
  "p-bottom-xxxs": "awsui_p-bottom-xxxs_18wu0_lw6ey_549",
  "p-left-xxxs": "awsui_p-left-xxxs_18wu0_lw6ey_554",
  "p-xxs": "awsui_p-xxs_18wu0_lw6ey_559",
  "p-top-xxs": "awsui_p-top-xxs_18wu0_lw6ey_563",
  "p-vertical-xxs": "awsui_p-vertical-xxs_18wu0_lw6ey_564",
  "p-right-xxs": "awsui_p-right-xxs_18wu0_lw6ey_568",
  "p-horizontal-xxs": "awsui_p-horizontal-xxs_18wu0_lw6ey_569",
  "p-bottom-xxs": "awsui_p-bottom-xxs_18wu0_lw6ey_573",
  "p-left-xxs": "awsui_p-left-xxs_18wu0_lw6ey_578",
  "p-xs": "awsui_p-xs_18wu0_lw6ey_583",
  "p-top-xs": "awsui_p-top-xs_18wu0_lw6ey_587",
  "p-vertical-xs": "awsui_p-vertical-xs_18wu0_lw6ey_588",
  "p-right-xs": "awsui_p-right-xs_18wu0_lw6ey_592",
  "p-horizontal-xs": "awsui_p-horizontal-xs_18wu0_lw6ey_593",
  "p-bottom-xs": "awsui_p-bottom-xs_18wu0_lw6ey_597",
  "p-left-xs": "awsui_p-left-xs_18wu0_lw6ey_602",
  "p-s": "awsui_p-s_18wu0_lw6ey_607",
  "p-top-s": "awsui_p-top-s_18wu0_lw6ey_611",
  "p-vertical-s": "awsui_p-vertical-s_18wu0_lw6ey_612",
  "p-right-s": "awsui_p-right-s_18wu0_lw6ey_616",
  "p-horizontal-s": "awsui_p-horizontal-s_18wu0_lw6ey_617",
  "p-bottom-s": "awsui_p-bottom-s_18wu0_lw6ey_621",
  "p-left-s": "awsui_p-left-s_18wu0_lw6ey_626",
  "p-m": "awsui_p-m_18wu0_lw6ey_631",
  "p-top-m": "awsui_p-top-m_18wu0_lw6ey_635",
  "p-vertical-m": "awsui_p-vertical-m_18wu0_lw6ey_636",
  "p-right-m": "awsui_p-right-m_18wu0_lw6ey_640",
  "p-horizontal-m": "awsui_p-horizontal-m_18wu0_lw6ey_641",
  "p-bottom-m": "awsui_p-bottom-m_18wu0_lw6ey_645",
  "p-left-m": "awsui_p-left-m_18wu0_lw6ey_650",
  "p-l": "awsui_p-l_18wu0_lw6ey_530",
  "p-top-l": "awsui_p-top-l_18wu0_lw6ey_659",
  "p-vertical-l": "awsui_p-vertical-l_18wu0_lw6ey_660",
  "p-right-l": "awsui_p-right-l_18wu0_lw6ey_664",
  "p-horizontal-l": "awsui_p-horizontal-l_18wu0_lw6ey_665",
  "p-bottom-l": "awsui_p-bottom-l_18wu0_lw6ey_669",
  "p-left-l": "awsui_p-left-l_18wu0_lw6ey_674",
  "p-xl": "awsui_p-xl_18wu0_lw6ey_679",
  "p-top-xl": "awsui_p-top-xl_18wu0_lw6ey_683",
  "p-vertical-xl": "awsui_p-vertical-xl_18wu0_lw6ey_684",
  "p-right-xl": "awsui_p-right-xl_18wu0_lw6ey_688",
  "p-horizontal-xl": "awsui_p-horizontal-xl_18wu0_lw6ey_689",
  "p-bottom-xl": "awsui_p-bottom-xl_18wu0_lw6ey_693",
  "p-left-xl": "awsui_p-left-xl_18wu0_lw6ey_698",
  "p-xxl": "awsui_p-xxl_18wu0_lw6ey_703",
  "p-top-xxl": "awsui_p-top-xxl_18wu0_lw6ey_707",
  "p-vertical-xxl": "awsui_p-vertical-xxl_18wu0_lw6ey_708",
  "p-right-xxl": "awsui_p-right-xxl_18wu0_lw6ey_712",
  "p-horizontal-xxl": "awsui_p-horizontal-xxl_18wu0_lw6ey_713",
  "p-bottom-xxl": "awsui_p-bottom-xxl_18wu0_lw6ey_717",
  "p-left-xxl": "awsui_p-left-xxl_18wu0_lw6ey_722",
  "p-xxxl": "awsui_p-xxxl_18wu0_lw6ey_727",
  "p-top-xxxl": "awsui_p-top-xxxl_18wu0_lw6ey_731",
  "p-vertical-xxxl": "awsui_p-vertical-xxxl_18wu0_lw6ey_732",
  "p-right-xxxl": "awsui_p-right-xxxl_18wu0_lw6ey_736",
  "p-horizontal-xxxl": "awsui_p-horizontal-xxxl_18wu0_lw6ey_737",
  "p-bottom-xxxl": "awsui_p-bottom-xxxl_18wu0_lw6ey_741",
  "p-left-xxxl": "awsui_p-left-xxxl_18wu0_lw6ey_746",
  "m-n": "awsui_m-n_18wu0_lw6ey_751",
  "m-top-n": "awsui_m-top-n_18wu0_lw6ey_755",
  "m-vertical-n": "awsui_m-vertical-n_18wu0_lw6ey_756",
  "m-right-n": "awsui_m-right-n_18wu0_lw6ey_760",
  "m-horizontal-n": "awsui_m-horizontal-n_18wu0_lw6ey_761",
  "m-bottom-n": "awsui_m-bottom-n_18wu0_lw6ey_765",
  "m-left-n": "awsui_m-left-n_18wu0_lw6ey_770",
  "m-xxxs": "awsui_m-xxxs_18wu0_lw6ey_775",
  "m-top-xxxs": "awsui_m-top-xxxs_18wu0_lw6ey_779",
  "m-vertical-xxxs": "awsui_m-vertical-xxxs_18wu0_lw6ey_780",
  "m-right-xxxs": "awsui_m-right-xxxs_18wu0_lw6ey_784",
  "m-horizontal-xxxs": "awsui_m-horizontal-xxxs_18wu0_lw6ey_785",
  "m-bottom-xxxs": "awsui_m-bottom-xxxs_18wu0_lw6ey_789",
  "m-left-xxxs": "awsui_m-left-xxxs_18wu0_lw6ey_794",
  "m-xxs": "awsui_m-xxs_18wu0_lw6ey_799",
  "m-top-xxs": "awsui_m-top-xxs_18wu0_lw6ey_803",
  "m-vertical-xxs": "awsui_m-vertical-xxs_18wu0_lw6ey_804",
  "m-right-xxs": "awsui_m-right-xxs_18wu0_lw6ey_808",
  "m-horizontal-xxs": "awsui_m-horizontal-xxs_18wu0_lw6ey_809",
  "m-bottom-xxs": "awsui_m-bottom-xxs_18wu0_lw6ey_813",
  "m-left-xxs": "awsui_m-left-xxs_18wu0_lw6ey_818",
  "m-xs": "awsui_m-xs_18wu0_lw6ey_823",
  "m-top-xs": "awsui_m-top-xs_18wu0_lw6ey_827",
  "m-vertical-xs": "awsui_m-vertical-xs_18wu0_lw6ey_828",
  "m-right-xs": "awsui_m-right-xs_18wu0_lw6ey_832",
  "m-horizontal-xs": "awsui_m-horizontal-xs_18wu0_lw6ey_833",
  "m-bottom-xs": "awsui_m-bottom-xs_18wu0_lw6ey_837",
  "m-left-xs": "awsui_m-left-xs_18wu0_lw6ey_842",
  "m-s": "awsui_m-s_18wu0_lw6ey_847",
  "m-top-s": "awsui_m-top-s_18wu0_lw6ey_851",
  "m-vertical-s": "awsui_m-vertical-s_18wu0_lw6ey_852",
  "m-right-s": "awsui_m-right-s_18wu0_lw6ey_856",
  "m-horizontal-s": "awsui_m-horizontal-s_18wu0_lw6ey_857",
  "m-bottom-s": "awsui_m-bottom-s_18wu0_lw6ey_861",
  "m-left-s": "awsui_m-left-s_18wu0_lw6ey_866",
  "m-m": "awsui_m-m_18wu0_lw6ey_871",
  "m-top-m": "awsui_m-top-m_18wu0_lw6ey_875",
  "m-vertical-m": "awsui_m-vertical-m_18wu0_lw6ey_876",
  "m-right-m": "awsui_m-right-m_18wu0_lw6ey_880",
  "m-horizontal-m": "awsui_m-horizontal-m_18wu0_lw6ey_881",
  "m-bottom-m": "awsui_m-bottom-m_18wu0_lw6ey_885",
  "m-left-m": "awsui_m-left-m_18wu0_lw6ey_890",
  "m-l": "awsui_m-l_18wu0_lw6ey_770",
  "m-top-l": "awsui_m-top-l_18wu0_lw6ey_899",
  "m-vertical-l": "awsui_m-vertical-l_18wu0_lw6ey_900",
  "m-right-l": "awsui_m-right-l_18wu0_lw6ey_904",
  "m-horizontal-l": "awsui_m-horizontal-l_18wu0_lw6ey_905",
  "m-bottom-l": "awsui_m-bottom-l_18wu0_lw6ey_909",
  "m-left-l": "awsui_m-left-l_18wu0_lw6ey_914",
  "m-xl": "awsui_m-xl_18wu0_lw6ey_919",
  "m-top-xl": "awsui_m-top-xl_18wu0_lw6ey_923",
  "m-vertical-xl": "awsui_m-vertical-xl_18wu0_lw6ey_924",
  "m-right-xl": "awsui_m-right-xl_18wu0_lw6ey_928",
  "m-horizontal-xl": "awsui_m-horizontal-xl_18wu0_lw6ey_929",
  "m-bottom-xl": "awsui_m-bottom-xl_18wu0_lw6ey_933",
  "m-left-xl": "awsui_m-left-xl_18wu0_lw6ey_938",
  "m-xxl": "awsui_m-xxl_18wu0_lw6ey_943",
  "m-top-xxl": "awsui_m-top-xxl_18wu0_lw6ey_947",
  "m-vertical-xxl": "awsui_m-vertical-xxl_18wu0_lw6ey_948",
  "m-right-xxl": "awsui_m-right-xxl_18wu0_lw6ey_952",
  "m-horizontal-xxl": "awsui_m-horizontal-xxl_18wu0_lw6ey_953",
  "m-bottom-xxl": "awsui_m-bottom-xxl_18wu0_lw6ey_957",
  "m-left-xxl": "awsui_m-left-xxl_18wu0_lw6ey_962",
  "m-xxxl": "awsui_m-xxxl_18wu0_lw6ey_967",
  "m-top-xxxl": "awsui_m-top-xxxl_18wu0_lw6ey_971",
  "m-vertical-xxxl": "awsui_m-vertical-xxxl_18wu0_lw6ey_972",
  "m-right-xxxl": "awsui_m-right-xxxl_18wu0_lw6ey_976",
  "m-horizontal-xxxl": "awsui_m-horizontal-xxxl_18wu0_lw6ey_977",
  "m-bottom-xxxl": "awsui_m-bottom-xxxl_18wu0_lw6ey_981",
  "m-left-xxxl": "awsui_m-left-xxxl_18wu0_lw6ey_986",
  "d-block": "awsui_d-block_18wu0_lw6ey_991",
  "d-inline": "awsui_d-inline_18wu0_lw6ey_994",
  "d-inline-block": "awsui_d-inline-block_18wu0_lw6ey_997",
  "d-none": "awsui_d-none_18wu0_lw6ey_1000",
  "f-left": "awsui_f-left_18wu0_lw6ey_1005",
  "f-right": "awsui_f-right_18wu0_lw6ey_1009"
};
  